import {ActionReducer, Action, ActionReducerMap} from '@ngrx/store';
import * as actions from '../actions';
import {DeviceDetails, DevicesStatus, DevicesStatusPack} from '../../models/devices';

export interface DevicesStatusState {
  isLoading: boolean;
  isLoaded: boolean;
  entities: DevicesStatusPack;
}

const initialState: DevicesStatusState = {
  isLoading: false,
  isLoaded: false,
  entities: {DeviceList: [], ShareDeviceList: [], ShareGroupDeviceList: []},
};

export interface DevicesDetailsState {
  isLoading: boolean;
  isLoaded: boolean;
  entities: DeviceDetails;
}

const initialDetailsState: DevicesDetailsState = {
  isLoading: false,
  isLoaded: false,
  entities: null
};


export function reducer(state: DevicesStatusState = initialState, action: actions.DevicesStatusActions): DevicesStatusState {
  switch (action.type) {
    case actions.DevicesStatusTypes.GET_DEVICES_STATUS:
      return {...state, isLoading: true, isLoaded: false, entities: state.entities};
    case actions.DevicesStatusTypes.GET_DEVICES_STATUS_SUCCESS:
      return {...state, isLoading: false, isLoaded: true, entities:
        {DeviceList: action.payload.DeviceList, ShareDeviceList: action.payload.ShareDeviceList,
           ShareGroupDeviceList: action.payload.ShareGroupDeviceList}};
    case actions.DevicesStatusTypes.GET_DEVICES_STATUS_FAIL:
      // 失敗時保留既有清單，避免 Share 更新後短暫 Fail 把 Device 整頁清掉
      return {...state, isLoading: false, isLoaded: true, entities: state.entities};
    case actions.DevicesStatusTypes.CLEAR_DEVICES_STATUS:
      return initialState;
    default:
      return state;
  }
}

export function selectedDashboardStatusReducer(state: number = -1, action: actions.DevicesStatusActions): number {
  switch (action.type) {
    case actions.DevicesStatusTypes.SELECTED_STATUS:
      return action.payload;
    default:
      return state;
  }
}


export function detailsReducer(state: DevicesDetailsState = initialDetailsState,
                               action: actions.DevicesStatusActions): DevicesDetailsState {
  switch (action.type) {
    case actions.DeviceDetailsType.GET_DEVICE_DETAILS:
      return {...state, isLoading: true, isLoaded: false, entities: state.entities};
    case actions.DeviceDetailsType.GET_DEVICE_DETAILS_SUCCESS:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    case actions.DeviceDetailsType.GET_DEVICE_DETAILS_FAIL:
      return {...state, isLoading: false, isLoaded: true, entities: null};
    default:
      return state;
  }
}

// for selector
export const getDevicesStatus = (state: DevicesStatusState) => state;
export const getDeivceDetailsState = (state: DevicesDetailsState) => state.entities;
